import React, { useEffect } from 'react';
import Head from 'next/head';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { formatDate } from '@root/src/utils/dates';
import getRoute from '@root/src/services/routeList';
import useEventInfo from '@root/src/hooks/useEventInfo';
import { useRollbarContext } from '@services/rollbar';
import ssrProvider from '@services/ssrProvider';
import { GET_DATA_FOR, getServerSideData } from '@services/dataHandler/getPageData';
import ReduxWrapper from '@services/store';
import { selectEventDetail } from '@features/eventDetail/slices/eventDetailServerSlice';
import EventEngagedTemplate from '@features/eventDetail/templates/EventEngagedTemplate';
import { getQueryEventId } from '@features/eventDetail/utils';

const EngagedPage = () => {
  useRollbarContext('Event : EngagedPage');
  const router = useRouter();
  const event = useSelector(selectEventDetail(getQueryEventId(router.query)));
  const { hasEngagedList } = useEventInfo(event);

  const eventSubscriptionStartDate = event?.status?.registrationFrom ? formatDate(event?.status?.registrationFrom) : '-';
  const eventSubscriptionEndDate = event?.status?.registrationTo ? formatDate(event?.status?.registrationTo) : '-';

  const { t } = useTranslation();

  useEffect(() => {
    if (!hasEngagedList) {
      router.push(getRoute.events(event.slug).description());
    }
  }, [hasEngagedList]);

  return (
    <>
      <Head>
        <title>{`${t('head_EventEngagedTitle.message', { event: event.name })} ${t('head_siteTitle.message')}`}</title>
        <meta
          name="description"
          content={
            t('head_EventEngagedDescription.message',
              {
                eventName: event.name,
                eventSubscriptionStartDate,
                eventSubscriptionEndDate,
              })
          }
        />
      </Head>
      <EventEngagedTemplate />
    </>
  );
};

export default EngagedPage;

export const getServerSideProps = ReduxWrapper.getServerSideProps(
  (store) => async (serverSideContext) => ssrProvider({
    store,
    serverSideContext,
    process: async ({ store }) => {
      await getServerSideData(
        store,
        serverSideContext,
        GET_DATA_FOR.EVENT_ENGAGED_LIST
      );
    },
  })
);
